import { render, staticRenderFns } from "./BlockGeneric.vue?vue&type=template&id=65a78332&"
import script from "./BlockGeneric.vue?vue&type=script&lang=js&"
export * from "./BlockGeneric.vue?vue&type=script&lang=js&"
import style0 from "./BlockGeneric.vue?vue&type=style&index=0&id=65a78332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports